import styled from "styled-components"

export interface StyledCarouselProps {
  no_of_slides: number
  slides_per_view_mobile: number
  slides_per_view_tablet: number
  slides_per_view_desktop: number
  slides_per_view_wide: number
}

export const StyledCarousel = styled.div`
  position: relative;

  & .swiper-slide {
    height: auto;
    & > div {
      height: 100%;
    }
  }
`

export const StyledModalCarousel = styled.div`
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  z-index: 100;
  background: red;
  left: 0;
  opacity: 1;
  ${(props) =>
    props.visible
      ? `
        opacity: 1;
        `
      : `
        opacity: 0;
        pointer-events: none;
        `}

  & .swiper-container {
    height: 100%;
  }

  & .swiper-wrapper {
    height: 100vh;
  }

  & .swiper-slide {
    overflow-y: scroll;
  }
`

export const StyledButton = styled.button<StyledCarouselProps>`
   position: absolute;
  top: 50%;
  left: -32px;
  transform: translateY(-50%);
  z-index: 1;
  background: ${(props) => props.theme.colors.white};
  box-shadow: 0 0 16px ${(props) => props.theme.colors.darkGrey10};
  border: 0;
  width: 64px;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
    /* width: 48px;
    height: 48px; */
    width: 36px;
    height: 44px;
    left: -24px;
    & i {
      svg {
        max-width: 14px;
        min-width: 14px;
        max-height: 14px;
        min-height: 14px;
      }
    }
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    left: -16px;
  }
  &:nth-of-type(2) {
    left: auto;
    right: -32px;
    @media (max-width: ${(props) => props.theme.breakPoints.tablet}) {
      right: -24px;
    }
    @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
      right: -16px;
    }
  }
  & svg {
    color: ${(props) => props.theme.colors.darkGrey};
  }
  &:disabled {
    cursor: initial;
    pointer-events: none;
    opacity: 0;
  }
  @media (min-width: ${(props) => props.theme.breakPoints.desktop}) {
    ${(props) =>
      props.no_of_slides < props.slides_per_view_wide &&
      `
      cursor: initial;
      pointer-events: none;
      opacity: 0;
    `}
  }
  @media only screen and (min-width: ${(props) =>
      props.theme.breakPoints.tablet}) and (max-width: ${(props) =>
      props.theme.breakPoints.desktop}) {
    ${(props) =>
      props.no_of_slides < props.slides_per_view_desktop &&
      `
      pointer-events: none;
      opacity: 0;
      cursor: initial;
      `}
  }
  @media only screen and (min-width: ${(props) =>
      props.theme.breakPoints.mobile}) and (max-width: ${(props) =>
      props.theme.breakPoints.tablet}) {
    ${(props) =>
      props.no_of_slides < props.slides_per_view_tablet &&
      `
      cursor: initial;
      pointer-events: none;
      opacity: 0;
    `}
  }
  @media (max-width: ${(props) => props.theme.breakPoints.mobile}) {
    ${(props) =>
      props.no_of_slides < props.slides_per_view_mobile &&
      `
      cursor: initial;
      pointer-events: none;
      opacity: 0;
    `}
  }
`
